(function() {
  function isReptileCollection() {
    var path = window.location.pathname || "";
    if (path.indexOf("/collections/") !== 0) return false;
    var handle = path.replace("/collections/", "").split("/")[0].toLowerCase();
    return handle === "reptile";
  }

  function normalizeText(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function applyGloboFilterClass() {
    if (!isReptileCollection()) return;

    var blocks = document.querySelectorAll(".gf-option-block");
    for (var i = 0; i < blocks.length; i++) {
      var title = blocks[i].querySelector(".gf-block-title .h3 span");
      var label = normalizeText(title ? title.textContent : "");
      if (label === "pet type" || label === "type") {
        blocks[i].classList.add("hide-filter");
      }
    }
  }

  function initGloboFilterClass() {
    applyGloboFilterClass();

    if (typeof MutationObserver === "undefined") return;
    var observer = new MutationObserver(function() {
      applyGloboFilterClass();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGloboFilterClass);
  } else {
    initGloboFilterClass();
  }

  window.addEventListener("globoFilterRenderCompleted", applyGloboFilterClass);
})();
